import { statusTypes } from "../config/constants";

export function getStringValidationState(state, element) {
  let text = state[element];
  if(typeof text !== 'string')
    return statusTypes.ERROR;
  const length = text.length;
  if (length > 0)
    return statusTypes.SUCCESS;
  return statusTypes.ERROR;
}

export function getNumberValidationState(state, element) {
  let number = state[element];
  if(isNaN(number))
    return statusTypes.ERROR;
  if(typeof number === 'string' && number.length < 1) // Empty string is not NaN
    return statusTypes.ERROR;
  return statusTypes.SUCCESS;
}

export function getOneOrMoreValidationState(state, element, equivalents) {
  const trueEquivs = equivalents.filter((equivalent) => state[equivalent]);
  return trueEquivs.length > 0 ?
    statusTypes.SUCCESS :
    statusTypes.ERROR;
}